import { render, staticRenderFns } from "./boughtArchives.vue?vue&type=template&id=1339ba3a&scoped=true"
import script from "./boughtArchives.vue?vue&type=script&lang=js"
export * from "./boughtArchives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1339ba3a",
  null
  
)

export default component.exports